<template>
  <div
    v-if="flashcardInstruction"
    class="flashcard-instruction"
  >
    <icon
      name="play-uui"
      variant="155EEF"
    ></icon>
    <span>
      {{ flashcardInstruction }}
    </span>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    flashcardInstruction: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.flashcard-instruction {
  font-size: rem-calc(16);
  line-height: rem-calc(24);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: rem-calc(8);
  margin-bottom: rem-calc(12);
}
</style>
